import Sidebar from "./Sidebar";
import AdminSidebar from "./AdminSidebar";
import './admin_dashboard.css';
import React, { useState, useEffect } from "react";
import { fetchItems,createItem } from "../api/networking";
import AdminAutoTaskItem from "./admin_auto_task_item";
import AdminNeedApprovalTask from "./admin_need_appr_task_item";
import AdminModal from "./admin_modal";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "motion/react";
import LoadingCircleSpinner from "../animation/loading";
import { FaSquareCaretLeft } from "react-icons/fa6";
import { FaSquareCaretRight } from "react-icons/fa6";
import AdminRedoTask from "./admin_redo_task";
import AdminModalRedo from "./admin_modal_redo";





const mockTasks = [
    { id: 1, name: "Monthly Report - July" },
    { id: 2, name: "Quarterly Review Q2" },
    { id: 3, name: "Quarterly Review Q3" },
    { id: 4, name: "Quarterly Review Q4" },
    { id: 5, name: "Quarterly Review Q5" },
    { id: 6, name: "Quarterly Review Q6" },
    { id: 7, name: "Quarterly Review Q7" },
    { id: 8, name: "Quarterly Review Q8" },
    { id: 9, name: "Quarterly Review Q9" },
    { id: 10, name: "Quarterly Review Q10" },
    { id: 11, name: "Quarterly Review Q11" },
    { id: 12, name: "Quarterly Review Q12" },
  ];

const addTasks = [

  ];

const doneTasks = [

  ];

  


const AdminDashboard = ({initials}) => {
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedRedoTask, setSelectedRedoTask] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalRedoOpen, setModalRedoOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showRedoModal, setShowRedoModal] = useState(false);
    const [pageSelected, setPageSelected] = useState([true,false,false,false,false])
    const [autoTasks, setAutoTasks] = useState([]);   
    const [needsApprovalTasks, setNeedsApprovalTasks] = useState([]);   
    const [inReviewTasks, setInReviewTasks] = useState([]); 
    const [redoTasks, setRedoTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [pageNumber, setPageNumber] = useState(1);
    const [maxPageNumber, setMaxPageNumber] = useState(1);
    



  
    const openModal = (task) => {
      setSelectedTask(task);
      setModalOpen(true);
    };

    const openRedoModal = (task) => {
      setSelectedRedoTask(task)
      setModalRedoOpen(true);
    };

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));



    const addTask = (task) => {
      
    };
  
    const closeModal = () => {
      setModalOpen(false);
      setSelectedTask(null);
    };

    const closeRedoModal = () => {
      setModalRedoOpen(false);
      setSelectedRedoTask(null);
    };

    const IncrementPageNumber = ()=>{
      setPageNumber(prev => prev + 1);
    }

    const DecrementPageNumber = ()=>{
      if(pageNumber >= 2){
        setPageNumber(prev => prev - 1);
      }
    }

    const fetchAutomaticTasks = async (page) => {
      setIsLoading(false);
      try {
        const data = await createItem( `/get_supplement_task_list?page=${page}`);
        console.log("Tasks:", data[1]['listOfTask']);
        console.log("Tasks:", data[1]['totalPage']);
        //setAutoTasks(data[1]['listOfTask']);
        //setMaxPageNumber(data[1]['totalPage']);
        setAutoTasks(data[1]['listOfTask']);
        setMaxPageNumber(data[1]['totalPage'] || 1);
        //setIsLoading(false);
      } catch (err) {
        console.error(err);
      }
    };


    const fetchNeedApprovalTasks = async () => {
      try {
        const data = await fetchItems('/get_financial_task_list');
        console.log("Needs Approval Tasks:", data);
        setNeedsApprovalTasks(data[1]);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchRedoTasks = async () => {
      try {
        const data = await fetchItems('/get_redo_task_list');
        setRedoTasks(data[1])
        console.log("Needs Approval Tasks API:");
      } catch (err) {
        console.error(err);
      }
    };

    const addNeedApprovalTasks = (index) => {
      const updatedList = [...inReviewTasks, needsApprovalTasks[index]];
      setInReviewTasks(updatedList);
    }

    useEffect(() => {
      if (pageSelected[0]) {
        setInReviewTasks([]);
        fetchAutomaticTasks(pageNumber);
      } else if (pageSelected[1]) {
        setInReviewTasks([]);
        fetchNeedApprovalTasks();
      }else if(pageSelected[4]){
        setRedoTasks([]);
        fetchRedoTasks();
        console.log("Redo Task Hit:");
      }

    }, [pageSelected, pageNumber]);
    

  
  return (
    <div className="dashboard">
    <AdminSidebar pageSelected={pageSelected} setPageSelected={setPageSelected}/>
    <div className="dashboard-content">
        {/* Top Static Header */}
        <div className="dashboard-header">
                <h1 className="dashboard-title">Welcome to the Admin Dashboard</h1>
                <div className="profile-circle drop-shadow" onClick={() => setShowModal(true)}>
                  {initials}
                </div>
          </div>
        <div>

        </div>
        {pageSelected[0]
        ?
        <div>
            <AdminAutoTaskItem listOfAutoTask={autoTasks}> </AdminAutoTaskItem>
            <div className="bottom-page-container">
              <button className="bottom-prev-button" onClick={DecrementPageNumber}><FaSquareCaretLeft className="bottom-next-prev-button-icon" /></button>
              <div className="bottom-next-prev-text">
                <p>{pageNumber} of <strong>{maxPageNumber}</strong></p>
              </div>
              <button className="bottom-next-button" onClick={IncrementPageNumber}><FaSquareCaretRight className="bottom-next-prev-button-icon" /></button>
            </div>
          </div>
        :null}

        {pageSelected[1]?
        <AdminNeedApprovalTask needApprovalFunction={addNeedApprovalTasks} listOfTask={needsApprovalTasks}></AdminNeedApprovalTask>
        :null}

        {pageSelected[2]?<main className="dashboard-main">
            <h2>Review Tasks</h2>

            <ul className="task-list">
                {inReviewTasks.map((task,index) => (
                <li key={index} className="task-item" onClick={() => openModal(task)}>
                    {task.name}
                  <p>Task Name: {task.stock_symbol} - {task.financial_type}</p>
                  <p>Task Status: {task.isapproved?"Approved":"Need Approval"}</p>
                  <p>Task Type: {task.financial_file_type}</p>
                  <p>Date Of Data Pull: {task.date_completed}</p>
                  <p>Year Of Financial Data:{task.date_of_financial_data} </p>
                </li>
                ))}
            </ul>
        </main>:null}

        {pageSelected[3]?<main className="dashboard-main">
            <h2>Done Tasks</h2>

            <ul className="task-list">
                {doneTasks.map((task) => (
                <li key={task.id} className="task-item" onClick={() => openModal(task)}>
                    {task.name}
                    <input type="checkbox"></input>
                </li>
                ))}
            </ul>
        </main>:null}

        {pageSelected[4]?<AdminRedoTask openredomodal={openRedoModal} listOfRedo={redoTasks}>

        </AdminRedoTask>:null}


      </div>
         {/* Modal */}
         {<AdminModal 
          modalOpen={modalOpen} 
          selectedTask={selectedTask} 
          closeModal={closeModal} 
          />
        }{
          <AdminModalRedo
          modalOpen={modalRedoOpen} 
          selectedTask={selectedRedoTask} 
          closeModal={closeRedoModal}  
          />
        }
  </div>
  );
};

export default AdminDashboard;